export default __webpack_public_path__ + "static/media/icon-add.4c1084e1.svg";